// extracted by mini-css-extract-plugin
export default {"hiddenScrollbar":"NotificationFilters_hiddenScrollbar__GJTeT"};